/**
 * @generated SignedSource<<6a5a542a7360a0cb436c22883e0f5309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ThreadType = "WELLBEING" | "WORK";
export type CompanionSessionListWidgetQuery$variables = Record<PropertyKey, never>;
export type CompanionSessionListWidgetQuery$data = {
  readonly threads: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly type: ThreadType;
        readonly " $fragmentSpreads": FragmentRefs<"CompanionSessionCard_thread">;
      };
    }>;
  };
};
export type CompanionSessionListWidgetQuery = {
  response: CompanionSessionListWidgetQuery$data;
  variables: CompanionSessionListWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "WELLBEING"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanionSessionListWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ThreadConnection",
        "kind": "LinkedField",
        "name": "threads",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ThreadEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CompanionSessionCard_thread"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "threads(first:3,type:\"WELLBEING\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompanionSessionListWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ThreadConnection",
        "kind": "LinkedField",
        "name": "threads",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ThreadEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ThreadSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "threads(first:3,type:\"WELLBEING\")"
      }
    ]
  },
  "params": {
    "cacheID": "ddcfac29b63df37dbf24a5a3591a6c24",
    "id": null,
    "metadata": {},
    "name": "CompanionSessionListWidgetQuery",
    "operationKind": "query",
    "text": "query CompanionSessionListWidgetQuery {\n  threads(first: 3, type: WELLBEING) {\n    edges {\n      node {\n        id\n        type\n        ...CompanionSessionCard_thread\n      }\n    }\n  }\n}\n\nfragment CompanionSessionCard_thread on Thread {\n  id\n  type\n  createdAt\n  title\n  summary {\n    body\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ade683ca21ac340f4306cb9058810dd";

export default node;
